export default __webpack_public_path__ + "static/media/auwal.aa7f369b.png";